import React from "react";
import { FormattedMessage } from "react-intl";
import CalendarIcon from "../../modules/calendar/Calender.jsx";

const DeliveryInfo = ({ deliveryDateString, periodicity, rule }) => (
  <>
    {periodicity !== "ONCE" && (
      <div className={"delivery-description"}>
        <FormattedMessage id="deliveryDescription" />
      </div>
    )}
  </>
);

export default DeliveryInfo;
